<template>
    <div class="details-container">
        <div class="hole-container">
            <!-- Header -->
            <div 
                class="header" style="position: fixed; top: 0;"
                :style="{ 'background-image': 'url(' + URL + '/' + course.Cover + ')' }"
            >
                <div class="inner-color">

                    <div class="inner-header">
                        <img class="header-hat" :src="Hat" alt="Hat">
                        <h3>{{ course.Title }}</h3>
                    </div>

                    <!-- <div class="header-nav">
                        <div class="nav-container">
                            <span class="nav-link">توضیحات و معرفی</span>
                            <span class="nav-link">نظرات شرکت کنندگان</span>
                        </div>
                    </div> -->
                </div>
            </div>

            <!-- Content -->
            <div class="header2" style="width: 100%; height: 95vw; position: relative; z-index: 100;">

                    <img @click="back" class="back" :src="Back" alt="Back">
            </div>
            <div class="content">
                <!-- Teacher Intro -->
                <div class="teacher-intro">
                    <img class="teacher" :src="Teacher" alt="Teacher">
                    <div class="intro-content">
                        <h5>معرفی این دوره از زبان بهروز ریاحی</h5>
                        <p style="direction: rtl;">{{ course.Desc }}</p>
                        <!-- <p style="direction: rtl;">{{ course.Desc | truncateText(200) }}</p> -->

                        <div class="btn-container">
                            <!-- 
                            <button 
                                @click="ShowText(course.Desc)"
                                class="btn btn-light"
                            >...بیشتر</button> 
                            -->
                            <button
                                @click="fullscreenChange"
                                class="btn btn-light"
                            >نمایش معرفی دوره</button>
                        </div>
                    </div>
                </div>

                <!-- Questions -->
                <div class="question-container">
                    <div class="question-content" style="text-align: center; direction: rtl;">
                        <h5>سوال دارید؟</h5>
                        <p> در صورتی که هر سوالی در مورد دوره دارید در ساعات اداری با شماره های:
                            <br>021-26768616<br>021-26768660<br>021-26768624<br>
                            تماس حاصل فرمایید یا در کادر زیر شماره خود را وارد نمایید تا همکاران ما با شما تماس بگیرند
                        </p>

                        <!-- <router-link tag="button" :to="{name: 'Advisor'}" class="btn btn-light">تماس با مرکز مشاوره</router-link> -->
                        <button style="height: 40pt; font-size: 0.8rem;" class="btn btn-light" @click="AdviceRequest('Telephonic')">درخواست تماس برای توضیحات بیشتر</button>
                    </div>
                    <img class="question" :src="Smart" alt="Smart">
                </div>
            </div>
        </div>

        <!-- Footer -->
        <div class="footer">
            <!-- TOP -->
            <div class="footer-top">
                <div class="sessions-count">
                    <span>تعداد جلسات:</span>
                    <span>{{ course.VideosCount }} جلسه (آنلاین)</span>
                </div>
                <!-- 
                <div class="sessions-time">
                    <span>زمان برگزاری:</span>
                    
                    <button class="btn btn-light btn-time">شنبه</button>
                    <button class="btn btn-light btn-time">۱شنبه</button>
                    <button class="btn btn-light btn-time active">۲شنبه</button>
                    <button class="btn btn-light btn-time">۳شنبه</button>
                    <button class="btn btn-light btn-time active">۴شنبه</button>
                    <button class="btn btn-light btn-time">۵شنبه</button>
                    <button class="btn btn-light btn-time active">جمعه</button>
                </div>
                -->
            </div> 

            <!-- BOTTOM -->
            <div class="footer-bottom">
                <div class="desc">
                    <span class="price" v-if="discount" style="text-decoration: line-through;">شهریه: {{ course.Price | comma }} تومان</span>
                    <span class="price" v-else>شهریه: {{ course.Price | comma }} تومان</span>

                    <!-- <span class="price" v-if="discount">شهریه: {{ course.Price | comma }} تومان</span> -->
                    <!-- <span class="price" v-else>شهریه: {{ (course.Price * ((100 - course.Discount) / 100)).toFixed(0) | comma }} تومان</span> -->

                    <span class="discount" v-if="discount">مبلغ قابل پرداخت جدید {{ (course.Price * ((100 - course.Discount) / 100)).toFixed(0) | comma }} تومان می‌باشد.</span>
                    <span class="discount" v-else>این دوره شامل تخفیف نمی‌شود.</span>
                </div>

                <router-link
                    tag="button" 
                    :to="{ name: 'BaseCourse', params: { course: course._id } }"
                    v-if="hasBoutghtBefore"
                    class="btn btn-light btn-shop"
                >ورود به دوره</router-link>
                <button 
                    v-else @click="paymentCheck"
                    class="btn btn-light btn-shop"
                >خرید دوره</button>
            </div>

            <fullscreen :fullscreen.sync="showFS" v-show="showFS" class="fullscreen">
                <a class="close-btn" @click="() => { this.showFS = false}">
                    <i class="far fa-times" aria-hidden="true"></i>
                </a>
                <video 
                    id="video" class="video-inner"
                    v-if="showFS"
                    controls
                    controlsList="nodownload"
                    autoplay
                >
                    <source
                        v-if="course.IntroFile"
                        :src="URL + '/' + course.IntroFile" 
                        type="video/mp4"
                    >
                    Your browser does not support the video tag.
                </video>
            </fullscreen>
        </div>

        <!-- Modals -->
        <pay-modal :walletCheck="walletCheck" :payOnline="payOnline"/>
        <course-request-modal :submitRequest="Submit" :type="requestType"/>
    </div>
</template>

<script>
import Hat from '@/assets/images/courses/details/hat.png';
import Back from '@/assets/images/courses/details/back.png';
import Hand from '@/assets/images/courses/details/hand.png';
import Smart from '@/assets/images/courses/details/smart.png';
import Pointer from '@/assets/images/courses/details/pointer.png';

import Teacher from '@/assets/images/teacher_test.png';

import { getRequest, postRequest, APP_API_URL } from '@/utils/libs/api-request';
const uniqid = require('uniqid');
import Cookies from 'js-cookie';

import moment from 'moment';

import CourseRequestModal from '@/components/modals/course_request_modal';
import PayModal from '@/components/modals/pay_modal';

export default {
    name: 'CourseDetails',
    beforeRouteEnter(to, from, next) {
        next(vm => {
            vm.prevRoute = from
        })
    },
    data() {
        return {
            Hat: Hat,
            Back: Back,
            Hand: Hand,
            Smart: Smart,
            Pointer: Pointer,

            showFS: false,

            Teacher: Teacher,

            URL: APP_API_URL(),

            course: {},
            discount: true,
            prevRoute: {},
            expireDate: undefined,
            hasBoutghtBefore: false,

            requestType: undefined
        }
    },
    mounted() {
        this.getCurrent();
    },
    components: {
        PayModal,
        CourseRequestModal
    },
    methods: {
        paymentCheck() {
            this.$modal.show('pay-modal');
        },

        AdviceRequest(type) {
            this.requestType = type;
            this.$modal.show('course-request-modal');
        },
        Submit(type, subject) {
            postRequest('/advice-requests/create', {
                subject: subject,
                type: type
            })
                .then(() => {
                    // response
                    this.$emit('alertMsg', 
                        { message: 'درخواست ثبت گردید', key: uniqid(), type: 'success' }
                    )
                })
                .catch((err) => {
                    // check auth
                    if (err.response) {
                        if (err.response.status == 401) {
                            Cookies.remove('access_cookie');
                            this.$router.push({ name: 'Login' });
                        }
                        else {
                            this.$emit('alertMsg', 
                                { message: err.response.data.message, key: uniqid(), type: 'error' }
                            )
                        }
                    }
                });
        },

        payOnline() {
            let price = (this.course.Price * ((100 - this.course.Discount) / 100)).toFixed(0);

            postRequest('/users/buy-course-online', { 
                courseId: this.course._id,
                coursePrice: price
            })
                .then((rsp) => {
                    document.location = rsp['data'].response;
                })
                .catch(err => {
                    // check auth
                    if (err.response) {
                        if (err.response.status == 401) {
                            Cookies.remove('access_cookie');
                            this.$router.push({ name: 'PreRegister' });
                        }
                    }
                })
                .finally(() => {
                    this.$modal.hide('pay-modal');
                });
        },

        walletCheck() {
            getRequest('/users/user')
                .then(rsp => {
                    // response
                    let data = rsp['data'];
                    let credit = data.Credit;
                    let price = (this.course.Price * ((100 - this.course.Discount) / 100)).toFixed(0);

                    if(credit >= price) {
                        postRequest('/users/buy-course', { 
                            courseId: this.course._id,
                            coursePrice: price
                        })
                            .then(() => {
                                // response
                                this.$modal.show('dialog', {
                                    title: 'توجه!',
                                    text: 'دوره با موفقیت خریداری شد',
                                    buttons: [
                                        {
                                            title: 'تایید',
                                            handler: () => { 
                                                this.$modal.hide('dialog');
                                                location.reload();
                                            }
                                        }
                                    ]
                                });
                            })
                            .catch(err => {
                                // check auth
                                if (err.response) {
                                    if (err.response.status == 401) {
                                        Cookies.remove('access_cookie');
                                        this.$router.push({ name: 'PreRegister' });
                                    }
                                }
                            })
                            .finally(() => {
                                this.$modal.hide('pay-modal');
                            });
                    } else {
                        this.$modal.hide('pay-modal');
                        this.$modal.show('dialog', {
                            title: 'توجه!',
                            text: 'موجودی شما کمتر از میزان لازم است. آیا مایل هستید به صفحه «سرمایه‌های من» جهت افزایش سرمایه منتقل شوید؟',
                            buttons: [
                                {
                                    title: 'بلی',
                                    handler: () => { 
                                        this.$router.push({ name: 'MyWealth' })
                                        this.$modal.hide('dialog');
                                    }
                                },
                                {
                                    title: 'خیر',
                                    default: true,
                                }
                            ]
                        });
                    }
                })
                .catch(err => {
                    // check auth
                    if (err.response) {
                        if (err.response.status == 401) {
                            Cookies.remove('access_cookie');
                            this.$router.push({ name: 'PreRegister' });
                        }
                    }
                });
        },
        fullscreenChange() {
            this.showFS = !this.showFS;
        },
        ShowText(txt) {
            this.$modal.show('dialog', {
                title: 'معرفی این دوره از زبان مدرس',
                text: txt,
                buttons: [
                    {
                        title: 'باشه',
                        default: true,
                    }
                ]
            });
        },
        getCurrent() {
            getRequest('/base-courses/find-one', { id: this.$route.params.id })
                .then((rsp) => {
                    this.course = rsp['data'].course;

                    getRequest('/users/user')
                        .then(rsp => {
                            // response
                            let data = rsp['data'];
                            if(data.UserCourses.indexOf(this.course._id) > -1) {
                                this.hasBoutghtBefore = true;
                            }
                        })
                        .catch(() => {
                            // error
                        });

                    let now = moment();
                    this.expireDate = moment(this.course.ExpireDate, 'YYYY/MM/DD HH:mm');

                    if (now.isSameOrBefore(this.expireDate)) this.discount = true;
                    else this.discount = false;

                    if(this.course.Discount == 0) this.discount = false;
                })
                .catch(err => {
                // check auth
                    if (err.response) {
                        if (err.response.status == 401) {
                            Cookies.remove('access_cookie');
                            this.$router.push({ name: 'Login' })
                        }
                    }
                });
        },
        back() {
            if(this.prevRoute.name) {
                this.$router.go(-1)
            } else {
                this.$router.push({ name: 'Khanesh' })
            }
        }
    }
}
</script>

<style scoped>
/* ---------------------------------------- */
/* ---------------- HEADER ---------------- */
/* ---------------------------------------- */
.details-container .header {
    height: 95vw;
    width: 100vw;

    position: relative;
    overflow: hidden;

    background-position: center;
    background-size: cover;
    background-repeat: no-repeat;
}
.details-container .header2 .back {
    height: 5vh;

    position: absolute;
    top: 10pt;
    right: 10pt;

    cursor: pointer;
}
.details-container .header .inner-color {
    height: 100%;
    width: 100%;

    background-color: rgba(0, 0, 0, 0.5);
}
.details-container .header .inner-header {
    height: calc(55vh - 50pt);
    width: fit-content;

    margin: auto;
    padding-bottom: 10vh;
    text-align: center;

    display: flex;
    flex-direction: column;
}
.details-container .header .inner-header .header-hat {
    height: 25vh;
    margin: auto auto 0;
}
.details-container .header .inner-header h3 {
    color: #ecedee;

    margin: -5vh auto auto;
}

/* ---------------------------------------- */
/* -------------- HEADER NAV -------------- */
/* ---------------------------------------- */
.details-container .header .header-nav {
    height: 50pt;
    background-color: #fff;

    border-top-left-radius: 40pt;
    border-top-right-radius: 40pt;
}
.details-container .header .nav-container {
    height: 50pt;
    width: calc(100vw - 30pt);
    
    display: flex;
    margin: auto;
}
.details-container .header .nav-container .nav-link {
    height: fit-content;
    width: 50%;
    max-width: 120pt;

    margin: auto auto 0;
    padding: 0 0 15pt !important;
  
    display: inline-block;

    color: #86888e;
    text-align: center;
    font-weight: bold;
    font-size: 1rem;

    border-bottom: 3px solid #fff;
}
.details-container .header .nav-container .nav-link.active,
.details-container .header .nav-container .nav-link:active,
.details-container .header .nav-container .nav-link:hover {
    color: #373b48;
    border-bottom: 3px solid #ed412c;
}
@media (max-width: 576px) {
    .details-container .header .nav-container .nav-link {
        max-width: 75pt;
        font-size: .7rem;
    }
}

/* ---------------------------------------- */
/* ---------------- CONTENT---------------- */
/* ---------------------------------------- */
.details-container .content {
    background-color: #ebecf1;
    margin-top: -50pt;
    border-top-left-radius: 40pt;
    border-top-right-radius: 40pt;
    position: relative;
}
/* skill up */
.details-container .content .skill-up {
    height: 35vh;
    max-height: 175pt;

    display: flex;
    direction: ltr;

    border-bottom: 5px solid #d1d1d1;
}
.details-container .content .skill-up .inner-content {
    height: 20vh;
    max-height: 100pt;
    width: 90%;

    display: flex;

    margin: auto;
    padding: 7pt;

    background-color: #22317d;
    border-radius: 10pt;
    box-shadow: 0 5pt 20pt #22317da2;
}
.details-container .content .skill-up .big-button {
    height: 100%;
    width: 40%;

    display: flex;
    flex-direction: column;

    border-radius: 10pt;
    background-image: linear-gradient(0, #ed412c, #ffc107);
}
.details-container .content .skill-up .slim-content {
    height: 100%;
    width: 15%;
    margin-left: 5%;

    display: flex;
    flex-direction: column;

    border-radius: 5pt;
    border: 1px solid #19235a;
    background-color: #1d2a6c;
    box-shadow: inset 0px 3pt 3pt #232b5061;
}
.details-container .content .skill-up .big-button img {
    width: 35%;
    max-width: 30pt;
}
.details-container .content .skill-up .slim-content img {
    width: 50%;
    max-width: 20pt;
}
.details-container .content .skill-up .big-button img,
.details-container .content .skill-up .slim-content img {
    margin: 15pt auto auto;
}
.details-container .content .skill-up .big-button span,
.details-container .content .skill-up .slim-content span {
    margin: auto auto 15pt;

    color: #fff;
    display: inline-block;
}
@media (max-width: 576px) {
    .details-container .content .skill-up .big-button img,
    .details-container .content .skill-up .slim-content img {
        margin: 10pt auto auto;
    }
    .details-container .content .skill-up .big-button span,
    .details-container .content .skill-up .slim-content span {
        font-size: .8rem;
        margin: auto auto 10pt;   
    }
}

/* teacher intro & questions */
.details-container .content .teacher-intro,
.details-container .content .question-container {
    display: flex;
    direction: ltr;

    position: relative;
    overflow: hidden;

    border-bottom: 5px solid #d1d1d1;
}
.details-container .content .teacher-intro {
    min-height: 45vh;
}
.details-container .content .question-container {
    min-height: calc(55vh + 20px);
}
.details-container .content .teacher-intro .teacher {
    height: 30vh;
    position: absolute;
    bottom: 0;
    right: 0;
}
.details-container .content .question-container .question {
    width: 55%;
    max-width: 40vh;
    position: absolute;
    top: 5vh;
    left: 0;
}
.details-container .content .teacher-intro .intro-content,
.details-container .content .question-container .question-content {
    min-height: 35vh;
    width: 60%;

    display: flex;
    flex-direction: column;

    background: transparent;
    z-index: 1;
}
.details-container .content .teacher-intro .intro-content {
    padding-left: 15pt;
    margin-top: 5vh;
}
.details-container .content .question-container .question-content {
    position: absolute;
    top: 5vh;
    right: 0;
    padding-right: 15pt;
}
.details-container .content .question-container .question-content h5 {
    text-align: center;
}
.details-container .content .teacher-intro .intro-content p,
.details-container .content .question-container .question-content p {
    margin-top: 7pt;
}
.details-container .content .teacher-intro .intro-content p,
.details-container .content .teacher-intro .intro-content button,
.details-container .content .question-container .question-content p,
.details-container .content .question-container .question-content button {
    color: #212529aa;
}
.details-container .content .teacher-intro .intro-content button,
.details-container .content .question-container .question-content button {
    border-radius: 15pt;
    height: 35pt;
    width: 150pt;
    border-width: 2pt;
    box-shadow: 0pt 4pt 4pt #ccc;
    background-color: #ebecf1;
}
.details-container .content .teacher-intro .intro-content button {
    margin-bottom: 10pt;
}
.details-container .content .teacher-intro .intro-content .btn-container {
    padding: 0;
    width: 100pt !important;
    margin: auto auto 0 0;
}
.details-container .content .question-container .question-content button {
    margin: auto auto 0 auto;
}
@media (max-width: 576px) {
    .details-container .content .question-container .question {
        left: -10%;
    }
    .details-container .content .teacher-intro .intro-content h5,
    .details-container .content .question-container .question-content h5 {
        font-size: 0.9rem;
    }
    .details-container .content .teacher-intro .intro-content p,
    .details-container .content .teacher-intro .intro-content button,
    .details-container .content .question-container .question-content p,
    .details-container .content .question-container .question-content button {
        font-size: 0.8rem;
    }
    .details-container .content .teacher-intro .intro-content p,
    .details-container .content .question-container .question-content p {
        margin-top: 0;
    }
    .details-container .content .teacher-intro .intro-content button {
        width: 90pt;
    }
    .details-container .content .question-container .question-content button {
        width: 110pt;
    }
}

/* ---------------------------------------- */
/* ---------------- FOOTER ---------------- */
/* ---------------------------------------- */
.details-container .hole-container {
    height: calc(100% - 160px + 6vh);
    overflow: scroll;
}
.details-container .footer {
    background-color: #fff;

    margin-top: -8vh;
    position: relative;
    z-index: 4;

    border-top-left-radius: 7vh;
    border-top-right-radius: 7vh;

    width: 100%;
    height: 160px;
}
/* footer top */
.details-container .footer .footer-top {
    width: calc(100vw - 14vh);
    margin: auto;
    padding: 10pt 0;

    display: flex;
    flex-direction: column;
}
.details-container .footer .footer-top .sessions-count,
.details-container .footer .footer-top .sessions-time {
    min-height: 2.2rem;

    display: flex;
    flex-direction: row;
}
.details-container .footer .footer-top .sessions-count span:first-child,
.details-container .footer .footer-top .sessions-time span:first-child {
    margin: auto 0 auto auto;
}
.details-container .footer .footer-top .sessions-count span:last-child {
    margin: auto auto auto 0;
}
.details-container .footer .footer-top .sessions-time button {
    border: 1px solid #ccc;
}

.details-container .footer .footer-top .sessions-time button {
    height: 30pt;
    width: 30pt;

    margin: 5px;
    padding: 0;
    border-radius: 20pt;

    font-size: .8rem;
}
.details-container .footer .footer-top .sessions-time .btn-time.active {
    color: #fff;
    background-color: #253ca7;
    box-shadow: 2px 2px 5px #253ca7;
}
@media (max-width: 576px) {
    .details-container .footer {
        margin-top: -6vh;
        border-top-left-radius: 5vh;
        border-top-right-radius: 5vh;
    }
    .details-container .footer .footer-top {
        width: calc(100vw - 6vh);
    }
    .details-container .footer .footer-top .sessions-count {
        min-height: 2.2rem;
        font-size: .9rem;
    }
    .details-container .footer .footer-top .sessions-time {
        min-height: 1.8rem;
        font-size: .7rem;
    }
    .details-container .footer .footer-top .sessions-time .btn-time {
        height: 20pt;
        width: 20pt;

        margin: 1px;
        padding: 0;
        border-radius: 10pt;

        font-size: 6px;
    }
    .details-container .footer .footer-top .sessions-time .btn-time.active {
        box-shadow: 0.5px 0.5px 2px #253ca7;
    }
}
/* footer bottom */
.details-container .footer .footer-bottom {
    width: 100%;
    padding: 20pt 15pt;

    display: flex;
    background-color: #fece02;
}
.details-container .footer .footer-bottom .desc {
    width: fit-content;
    margin: auto 0 auto auto;

    display: flex;
    flex-direction: column;
}
.details-container .footer .footer-bottom .price {
    font-size: 1.3rem;
    font-weight: bold;
}
.details-container .footer .footer-bottom .discount {
    color: #212529aa;
}
.details-container .footer .footer-bottom .btn-shop {
    color: #fff;
    background-color: #f3481a;
    border-color: #f3481a;
    border-radius: 10pt;
    box-shadow: 1px 2px 8px #f3481add;

    margin: auto auto auto 0;
}
.details-container .footer .footer-bottom .btn-shop:not(:disabled):not(.disabled):active, 
.details-container .footer .footer-bottom .btn-shop:not(:disabled):not(.disabled).active,
.details-container .footer .footer-bottom .btn-shop:hover,
.details-container .footer .footer-bottom .btn-shop:active,
.details-container .footer .footer-bottom .btn-shop:focus {
    background-color: #fb3131;
    border-color: #fb3131;
}
.details-container .footer .footer-bottom .btn-shop.disabled, 
.details-container .footer .footer-bottom .btn-shop:disabled {
    background-color: #fb3131;
    border-color: #fb3131;
}
@media (max-width: 576px) {
    .details-container .footer .footer-bottom .price {
        font-size: 1.1rem;
    }
    .details-container .footer .footer-bottom .discount {
        font-size: .7rem;
    }
}

/* ---------------------------------------- */
/* -------------- FULL SCREEN ------------- */
/* ---------------------------------------- */
.fullscreen {
    display: flex;
    position: relative;
    color: #fff;
}
.fullscreen .close-btn {
  position: absolute;
  top: 5pt;
  right: 10pt;
  z-index: 1;

  font-size: 2rem;
  cursor: pointer;
}
.fullscreen .video-inner{
    height: 100%;
    width: 100%;
    margin: auto;
    background-color: #000;
}
</style>